export default "__VITE_ASSET__BzF9IBHG__"